"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsableDraggableContainer = void 0;
var core_1 = require("@dnd-kit/core");
var modifiers_1 = require("@dnd-kit/modifiers");
var sortable_1 = require("@dnd-kit/sortable");
var react_1 = __importStar(require("react"));
var CollapsableDraggableItem_1 = require("./CollapsableDraggableItem");
function CollapsableDraggableContainer(props) {
    var sensors = (0, core_1.useSensors)((0, core_1.useSensor)(core_1.PointerSensor), (0, core_1.useSensor)(core_1.KeyboardSensor), (0, core_1.useSensor)(core_1.TouchSensor));
    var _a = (0, react_1.useState)(''), inDraggingOverId = _a[0], setInDraggingOverId = _a[1];
    return (react_1.default.createElement(core_1.DndContext, { sensors: sensors, collisionDetection: core_1.closestCenter, onDragEnd: function (evt) {
            props.handleDragEnd(evt);
            setInDraggingOverId('');
        }, onDragOver: handleDragOver, modifiers: [modifiers_1.restrictToVerticalAxis] },
        react_1.default.createElement(sortable_1.SortableContext, { items: props.sortedElements, strategy: sortable_1.verticalListSortingStrategy }, props.sortedElements.map(function (ele) {
            var _a;
            var dragOverStyle = ele.id.toString() === inDraggingOverId ? props.dragOverStyle : ele.itemStyle;
            return (react_1.default.createElement("div", { key: ele.keyIndex, style: dragOverStyle },
                react_1.default.createElement(CollapsableDraggableItem_1.CollapsableDraggableItem, { id: ele.id, alterComponent: ele.alterElementInDragging, handleStyle: props.handleStyle, dragOverStyle: dragOverStyle, disabled: (_a = ele.disabled) !== null && _a !== void 0 ? _a : false, hideHandle: ele.hideHandle, className: ele.className }, ele.reactElement)));
        }))));
    function handleDragOver(event) {
        var active = event.active, over = event.over;
        if (over && over.id !== active.id) {
            setInDraggingOverId(String(over.id));
        }
        if (props.handleDragOver) {
            props.handleDragOver(event);
        }
    }
}
exports.CollapsableDraggableContainer = CollapsableDraggableContainer;
